import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

const isBrowserDefaultDark = (): boolean =>
  typeof window !== "undefined" ? window.matchMedia("(prefers-color-scheme: dark)").matches : false;

export const darkModeAtom = atom(isBrowserDefaultDark());
darkModeAtom.debugLabel = "darkModeAtom";

export const cultureAtom = atomWithReset<string>("en");
cultureAtom.debugLabel = "cultureAtom";

export const isRTLAtom = atom((get) => {
  const culture = get(cultureAtom);
  return culture.startsWith("ar") || culture.startsWith("he");
});
isRTLAtom.debugLabel = "isRTLAtom";

export const navigationCollapsedAtom = atom(false);
navigationCollapsedAtom.debugLabel = "navigationCollapsedAtom";

export const globalLoadingAtom = atom(false);
globalLoadingAtom.debugLabel = "globalLoadingAtom";

export const globalErrorAtom = atom<Error | null>(null);
globalErrorAtom.debugLabel = "globalErrorAtom";

export const unreadNotificationsAtom = atom<number>(0);
unreadNotificationsAtom.debugLabel = "unreadNotificationsAtom";

// Unread messages count
export const unreadMessagesAtom = atom<number>(0);
unreadMessagesAtom.debugLabel = "unreadMessagesAtom";
